export default __webpack_public_path__ + "static/IllustrationPoseComparison-b5d48769555499319f93055180aec4ad.svg";